import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';

const styleMaskIcon = (
    src: string,
    color = 'black',
    size = 24
): SxProps<Theme> => ({
    maskImage: `url(${src})`,
    maskSize: 'cover',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    backgroundColor: color,
    width: size,
    height: size,
});

interface DynamicIconProps {
    /** should be the URL of a PNG or SVG image with transparency */
    src: string;
    /** color of the icon (default black) */
    color?: string;
    /** size of the icon in pixels (default 24) */
    size?: number;
    sx?: SxProps<Theme>;
}
export function DynamicIcon({ color, src, size, sx }: DynamicIconProps) {
    return <Box sx={sxAppend(styleMaskIcon(src, color, size), sx)}></Box>;
}
